export const CONTABIL_COMPANY_LINK_ROUTE = '/configurar-empresa';
export const CONTABIL_COMPANY_LINK_TOAST_DURATION_SECONDS = 3;
export const CONTABIL_COMPANY_LINK_SUCCESS_TOAST_KEY = 'contabil-company-link-success-toast';
export const CONTABIL_COMPANY_LINK_SKIPPED_KEY = 'contabil-company-link-skipped';
export const CONTABIL_COMPANY_LINK_COMPLETED_KEY = 'contabil-company-link-completed';
